export default __webpack_public_path__ + "static/media/bbq03.3deef2fa.png";